import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ConstUserGroupEnum } from "../../../../models/ConstUserGroupEnum";
import { ObjectTypeNamesEnum } from "../../../../models/ObjectTypeEnum";
import { messagesApi } from "../../../../utils";
import { throwApiError } from "../../../lms-shared/store/error-handling-actions";
import BtnSelect from "../../../UI/Buttons/BtnSelect";
import InputFile from "../../../UI/Inputs/InputFile/InputFile";
import classes from "./StudentBanner.module.css";

const StudentBanner = () => {

    const [data, setData] = useState()
    const applicationId = useSelector(state => state.application.applicationId);
    const uiData = useSelector((state) => state.general.uiData);
    const texts = useSelector(state => state.translate.texts);
    const componentMounted = useRef(true);
    const dispatch = useDispatch();

    useEffect(() => {
        if (uiData) {
            const data = {
                refObjectType: ObjectTypeNamesEnum.Application,
                refObjectId: applicationId,
                targetObjects: [
                    { type: ObjectTypeNamesEnum.ConstUserGroup, id: ConstUserGroupEnum.Student },
                ],
                includeMessageTypesIds: [uiData.bannerMessageTypeId]
            }

            messagesApi.messagesFilterRangePost({ messagesRangeFilter: data }, (error, resdata, response) => {
                if (error) {
                    dispatch(throwApiError({ userMessage: texts.MessageContentMessagesFilterRange, error: error, statusCode: response?.statusCode, message: "MessagecontentMessagesFilterRange " + error.message, level: 2, component: "MessagesPage", line: 45 }))
                } else {
                    if (componentMounted.current) {
                        if (resdata.length > 0 && resdata[0].contents && resdata[0].contents.length > 0) {
                            const contents = {
                                he: { verticalImage: { url: "" }, horizontalImage: { url: "" }, link: "" },
                                ar: { verticalImage: { url: "" }, horizontalImage: { url: "" }, link: "" },
                                en: { verticalImage: { url: "" }, horizontalImage: { url: "" }, link: "" },
                            }

                            let link;
                            resdata[0].contents.forEach(c => {
                                const parse = JSON.parse(c.content)
                                contents[c.lang].verticalImage = { url: `${c.baseUrl}/${parse.verticalImage}`, fileName: parse.verticalImage };
                                contents[c.lang].horizontalImage = { url: `${c.baseUrl}/${parse.horizontalImage}`, fileName: parse.horizontalImage };
                                link = parse.link
                            });

                            setData({
                                id: resdata[0].id,
                                contents: contents,
                                link: link
                            })
                        }
                    }
                }
            })


            //fetch message banner
            // set message content 

        }
    }, [applicationId, uiData])


    useEffect(() => {
        return () => {
            componentMounted.current = false;
        }
    }, [])


    const save = () => {
        const jsonContents = { ...data.contents };
        Object.keys(jsonContents).forEach(c => jsonContents[c] = JSON.stringify({
            verticalImage: jsonContents[c].verticalImage.fileName,
            horizontalImage: jsonContents[c].horizontalImage.fileName,
            link: data.link
        }))

        let messageAddOrUpdateInput = {
            id: data.id,
            refObjectId: applicationId,
            refObjectType: ObjectTypeNamesEnum.Application,
            contents: jsonContents,
        }

        messagesApi.messagesUpdatePost({ messageAddOrUpdateInput: messageAddOrUpdateInput }, (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: texts.genralErrorMessage, error: error, statusCode: response?.statusCode, message: "genralErrorMessage " + error.message, level: 2, component: "StudentBanner", line: 89 }))
            } else {

            }
        })
    }

    const handleChange = (n, v) => {
        setData(preData => ({ ...preData, [n]: v }))
    }

    const handleChangeFile = (lang, type, fileData) => {
        const jsonData = {
            messageId: data.id,
            lang: lang,
            replaceFilename: data.contents[lang][`${type}Image`].fileName,
            file: fileData.file
        }

        messagesApi.messagesUpdateMessageContentFilePost(jsonData, (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: texts.genralErrorMessage, error: error, statusCode: response?.statusCode, message: "genralErrorMessage " + error.message, level: 2, component: "StudentBanner", line: 111 }))
            } else {
                setData(prevData => {
                    const parse = JSON.parse(resdata.content)
                    const newData = { ...prevData, contents: { ...prevData.contents, [lang]: { ...prevData.contents[lang] } } }
                    newData.contents[lang].verticalImage = { url: `${resdata.baseUrl}/${parse.verticalImage}`, fileName: parse.verticalImage };
                    newData.contents[lang].horizontalImage = { url: `${resdata.baseUrl}/${parse.horizontalImage}`, fileName: parse.horizontalImage };
                    return newData;
                })
            }
        })
    }

    return <div className={classes.StudentBanner}>
        {data && <>
            <div className={classes.Part}>
                <div className={classes.Label}>{texts.enterLink}</div>
                <div>
                    <input className={classes.LinkInput} type={"text"} value={data.link} name={"link"} onChange={(e) => handleChange("link", e.target.value)}></input>
                    <BtnSelect onClick={save} dropClass={classes.Btn} checked>{texts.change}</BtnSelect>
                </div>

            </div>
            <div className={classes.Part}>
                <div className={classes.Label}>{texts.verticalBanner} <span className={classes.ImageSize}>280px X 560px</span></div>
                <div className={classes.VerticalImages}>
                    {Object.keys(data.contents).map(lang => <div className={classes.ImageWrap} key={`${lang}Vertical`}>
                        <div className={classes.Lang}>{texts[lang]}</div>
                        <div className={classes.Image} style={{ backgroundImage: `url(${data.contents[lang].verticalImage.url})` }}></div>
                        <div className={classes.InputFileWrap}>
                            <InputFile
                                name={`${lang}ImageVertical`}
                                key={`${lang}ImageVertical`}
                                showName={false}
                                text={texts.change}
                                fileData={data.contents[lang].verticalImage}
                                setFileData={(fileData) => handleChangeFile(lang, "vertical", fileData)} />
                        </div>
                    </div>)}
                </div>
            </div>
            <div className={classes.Part}>
                <div className={classes.Label}>{texts.horizontalBanner} <span className={classes.ImageSize}>790px X 100px</span></div>
                <div className={classes.HorizontalImages}>
                    {Object.keys(data.contents).map(lang => <div className={`${classes.HorizontalImageWrap} ${classes.ImageWrap}`} key={`${lang}Horizontal`}>
                        <div className={classes.Lang}>{texts[lang]}</div>
                        <div className={classes.Image} style={{ backgroundImage: `url(${data.contents[lang].horizontalImage.url})` }}></div>
                        <div className={classes.InputFileWrap}>
                            <InputFile
                                name={`${lang}ImageHorizontal`}
                                key={`${lang}ImageHorizontal`}
                                showName={false}
                                text={texts.change}
                                fileData={data.contents[lang].horizontalImage}
                                setFileData={(fileData) => handleChangeFile(lang, "horizontal", fileData)} />
                        </div>
                    </div>)}
                </div>
            </div>
        </>}

    </div>
}
export default StudentBanner;